module.exports = __webpack_public_path__ + "img/keyboard_arrow.78352adc.svg";